module.exports = __webpack_public_path__ + "static/media/ddex.116cc5bc.svg";